import React from "react";
import { CustomLoader } from "./styled";

const Loader = () => {
  return (
    <CustomLoader className="container">
      <div className="loading__letter">T</div>
      <div className="loading__letter">r</div>
      <div className="loading__letter">a</div>
      <div className="loading__letter">v</div>
      <div className="loading__letter">i</div>
      <div className="loading__letter">y</div>
      <div className="loading__letter">a</div>
      <div className="loading__letter">.</div>
      <div className="loading__letter">.</div>
      <div className="loading__letter">.</div>
    </CustomLoader>
  );
};

export default Loader;
